<template>
  <div
    class="app-container"
    :class="{
      'app-container--drawer-header': isDrawer,
      'app-container--back-header': !isDrawer,
      'app-container--navigation-footer': showNavigationFooter,
      'app-container--mismatch': mismatch,
      'app-container--fullwidth': fullWidth,
    }"
  >
    <img v-if="mismatch" src="/user/logout/image" class="app_logoutimg">
    <div class="main-contents" :class="{ 'container': container }">
      <slot></slot>
    </div>

    <fixed-background
      v-if="fixedBgStatus"
      :all-height="allHeight"
      :scroll-position="scrPos"
      :fixed-bg-status="fixedBgStatus"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { throttle } from 'throttle-debounce'
import NavigationDrawer from './NavigationDrawer'
import AppHeader from './AppHeader'
import AppFooter from './AppFooter'
import * as types from '@/utvStore/store/mutation-types'
import fetchAccountData from '@/utils/fetchAccountData'
import DrawerHeader from './common/DrawerHeader'
import BackHeader from './common/BackHeader'
import NavigationFooter from './common/NavigationFooter'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import BasicModal from '@/utvStore/components/common/BasicModal'

/*
setTimeout(function () {
  document.getElementsByClassName("loading-font")[0].classList.add("loading-delay");
}, 1000);
*/
export default {
  name: 'app-container',
  props: {
    data: Object,
    tokenFlg: String,
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    showNavigationFooter: {
      type: Boolean,
      default: false
    },
    headerLayout: {
      type: String
    },
    container: {
      type: Boolean,
      default: true
    },
    preRegist: {
      type: Boolean,
      default: false
    },
    awsPrefix: {
      type: String,
      default: ''
    },
    userPoints: {
      type: String,
      default: ''
    },
    isDrawer: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ''
    },
    fixedBgStatus: {
      type: Number,
      default: 1
    },
    sessionAccessToken: {
      type: String,
      default: ''
    },
    fromSubscRegist: {
      type: Number,
      default: 0
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    headerAutoHide: {
      type: Boolean,
      default: false
    },
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NavigationDrawer,
    AppHeader,
    DrawerHeader,
    BackHeader,
    NavigationFooter,
    FixedBackground,
    BasicModal,
  },
  data () {
    return {
      mismatch: false,
      isShowFooter: false,
      // fixed-background プロパティ
      scrPos: 0,
      allHeight: 0,
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      accessToken: state => state.auth.accessToken,
      uiState: state => state.uiState
    })
  },
  watch:{
    uiState:{
      handler(n){
        if(this.isDrawer){
          this.bodyLock(n)
          this.footerToggle(n)
        }
      },
      deep: true
    }
  },
  created() {
    // storeでリセットが必要なものはここでリセットする
    this.$store.dispatch(types.RESET_FAV_CHECKLIST)
    this.$store.dispatch(types.RESET_TAG_ITEMS)
    this.$store.dispatch(types.RESET_VIDEO_ITEMS)
    this.$store.dispatch(types.RESET_COLOR_SCHEME)
    this.$store.dispatch(types.IS_LP, false)
    this.$store.dispatch(types.GLOBAL_LOCK, false)
    this.$store.dispatch(types.CLOSE_BASIC_MODAL)
  },
  mounted() {
    const mq = matchMedia('(min-width: 768px)');
    this.setDevice(mq)
    mq.addListener(this.setDevice)

    // ログインしている場合はユーザー情報を更新
    /*
    if (this.isLoggedIn) {
      fetchAccountData.getProfile(this.accessToken)
        .then()
        .catch(error => {
          // エラー処理 access_tokenの不整合の場合はフロント側ログアウト処理を行う
          this.$store.dispatch(types.LOGOUT)
        })
    }
    */

    // スクロール情報を初期化
    this.$store.commit(types.RESET_SCROLL_TOP)
    this.startWatchingScroll()
    /**
     * フロント (LocalStorage) と サーバー(Session) でのログイン状態の不整合の解消
     * tokenFlg が0(Sessionにログイン情報がない)の場合フロントのログイン情報を削除する
     **/
    if(this.fromSubscRegist){
      //サブスク登録後の遷移だった場合は、ここでisLoggedIn（ログイン状態）をtrueにする
      this.$store.commit(types.SET_ACCESS_TOKEN, this.sessionAccessToken)
    }else{
      if (undefined !== typeof this.tokenFlg) {
        if (this.tokenFlg === '0' && this.isLoggedIn) {
          this.$store.dispatch(types.LOGOUT)
        } else if (this.tokenFlg == '1' && !this.isLoggedIn) {
          this.mismatch = true;
          // storageからもトークンを消す
          this.$store.dispatch(types.LOGOUT).then(() => {
            location.href = `/user/logout`
          })
        }
      }
    }

    // fixed-background 用
    window.onresize = this.setAllHeight
    window.onscroll = this.onBaseScroll
    this.$nextTick(()=>this.setAllHeight())

    this.$nextTick(()=>this.footerToggle(this.uiState))
  },
  methods: {
    startWatchingScroll: function() {
      document.addEventListener(
        'scroll',
        throttle(100, () => {
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop
          this.$store.commit(types.UPDATE_SCROLL_TOP, scrollTop)
        })
      )
    },
    footerToggle(uiState){
      if(uiState.isLp){
        //LPの場合はフッター非表示
        this.isShowFooter = false
      }else{
        //SP:ドロワーヘッダーの場合はドロワーが開いている時にフッター非表示 PC:フッター（サイドメニュー）は常に表示
        if(this.isDrawer && !uiState.isPc) this.isShowFooter = !uiState.showAccountModal && !uiState.showDrawerMenu
        else this.isShowFooter = true
      }
    },
    // fixed-background 用
    setAllHeight(){
      this.allHeight = this.$el.clientHeight
    },
    // fixed-background 用
    onBaseScroll(e) {
      this.scrPos = window.pageYOffset
    },
    bodyLock(uiState) {
      // bodyのスクロールを無効にする
      if(!this.uiState.isPc){
        if(uiState.showAccountModal || uiState.showDrawerMenu){
          document.body.style.overflow = 'hidden'
          document.body.style.position = 'fixed'
          document.body.style.width = '100%'
        }else{
          document.body.style.overflowX = 'hidden'
          document.body.style.overflowY = 'auto'
          document.body.style.position = 'static'
          document.body.style.width = 'auto'
        }
      }
    },
    setDevice(mq){
      this.$store.dispatch(types.IS_PC, mq.matches)
    }
  }
}</script>

<style lang="scss">
.app-container {
  max-width: 580px;
  margin: 0 auto;
  &--drawer-header,
  &--back-header {
    padding-top: 44px;
  }
  &--navigation-footer {
    padding-bottom: 50px;
  }
  &--mismatch {}
  &--fullwidth {
    max-width: none;
  }
}
.app_logoutimg {
  width: 0;
  height: 0;
  display: block;
}
.main-contents {
  width: 100%;
  min-height: 100%;
}
.loading-font {
    visibility: hidden;
}
.wf-active, .loading-delay {
  visibility: visible;
}
.nav-footer {
  &.unvisible {
    visibility: hidden;
    pointer-events: none;
    position: static!important;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppContainer.vue